import { ArrowRight, Filter, Search, Calendar, Plus } from "react-feather";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../expenseList.module.css";
import { useAuth0 } from "@auth0/auth0-react";

const ListFilters = ({ setPage, setFilterData, setFilterOpen, filterOpen, filterData, selectProperty, propertyList, apartmentList, setCurrentFilterValue, expenseCategories, payeeList }) => {
  const { user, isAuthenticated } = useAuth0();

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); setPage(0); setCurrentFilterValue("search"); }} />
      </div>
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Property</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Property"
              value={filterData?.property}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, property: e.target.value };
                });
                selectProperty(e.target.value);
                setCurrentFilterValue("property");
              }}
            >
              {propertyList?.map((i) => {
                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Payee</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Payee"
              value={filterData?.payee}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, payee: e.target.value };
                });
                setCurrentFilterValue("payee");
              }}
            >
              {payeeList && payeeList?.map((i) => {
                return (<MenuItem key={i.id} value={i.id}>{i.company_name}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Category</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Apartment"
              value={filterData?.category}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, category: e.target.value };
                });
                setCurrentFilterValue("category");
              }}
            >
              {expenseCategories && expenseCategories?.map((i) => {
                return (<MenuItem key={i.id} value={i.id}>{i.title}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Status"
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, status: e.target.value };
                });
                setCurrentFilterValue("status");
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value={1}>Due</MenuItem>
              <MenuItem value={2}>Paid</MenuItem>
              <MenuItem value={0}>Upcoming</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, due_date: date };
                });
                setCurrentFilterValue("due_date");
              }}
            />
          </div>
        </div>
      </div>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense:create") > -1 && <div className={`${styles.ListGridBUCard}`}>
        <Link to={"/expense/all-expense/add"} className={`${styles.AddNoteBu}`}>
          <Plus /> <span>New Expense</span>
        </Link>
      </div>}

      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
        <Filter />
      </Link>
    </div>
  </div>);
};

export default ListFilters;